export function formatPercentWithSign(value: number): string {
    const s = Math.abs(value).toFixed(2);
    if (value > 0) {
        return `+${s}%`;
    } else if (value < 0) {
        return `-${s}%`;
    } else {
        return `0%`;
    }
}

export function formatPercent(value: number): string {
    const s = Math.abs(value).toFixed(2);
    if (value === 0) {
        return `0%`;
    } else {
        return `${s}%`;
    }
}

export function formatDecimal(value: number): string {
    return Math.abs(value)
        .toFixed(2)
        .toString();
}

export function insertSpaces(value: string): string {
    if (!value || !value.length) {
        return '';
    }
    return value.replace('_', ' ').replace('-', ' ');
}
